namespace GeniuzPOS.InitialData {
    export class PsPurposeReasonColumns {
        static columnsKey = 'InitialData.PsPurposeReason';
    }
}
